/**
 * @typedef {import('src/lib/type').SearchHit} SearchHit
 */

/**
 * Sets search data in localStorage based on the suggestion.
 * @param {SearchHit} suggestion - The suggestion.
 * @returns {string | undefined} - The company slug or undefined if not found.
 */
export function setSearchLocalStorage(suggestion) {
  if (!suggestion) {
    throw new Error('The suggestion must be provided');
  }

  const id = parseInt(suggestion.id, 10);

  if (suggestion.type === 'category') {
    localStorage.setItem('HeroSearchCategoryId', id);
    localStorage.setItem('HeroSearchSubCategories', null);
  } else if (suggestion.type === 'subcategory') {
    localStorage.setItem('HeroSearchCategoryId', suggestion.parentId);
    localStorage.setItem('HeroSearchSubCategories', suggestion.title);
  }

  localStorage.setItem(
    'HeroRegion',
    '{"name": "All", "type":"region"}'
  );
}
